// Meta component to not use react-router links when HF is remote
import { Link } from 'react-router';
import { connect } from 'react-redux';

import { ABSOLUTE_URL_RE } from 'common/regex';

export const HFLink = ({ isRemote, origin, to, children, ...otherProps }) => {

  const checkIfExternalAbsoluteUrl = () => {
    if (to) {
      const url = to.match(ABSOLUTE_URL_RE);
      return url && url?.[1] !== origin;
    }
  };

  if (isRemote || checkIfExternalAbsoluteUrl()) {
    return <a href={to} {...otherProps}>{children}</a>;
  }
  return <Link to={to} {...otherProps}>{children}</Link>;
};

function mapStateToProps(state) {
  return {
    isRemote: state.headerFooter.isRemote,
    origin: state.url.host
  };
}

export default connect(mapStateToProps, {})(HFLink);
